export const passwordRecovery = (carrierDomain, userId, setLoading, setResetComplete, setError) => {
  const url = carrierDomain + `/api/v1/authn/recovery/password`;
  return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ username: userId, factorType: 'EMAIL' }),
    })
      .then(() => {
        setLoading(false);
        setResetComplete(true);
      })
      .catch((e) => {
        console.log(e);
        setError(true);
      });
};
